// extracted by mini-css-extract-plugin
export default {"addToCartControl":"CZ-z","giftCard":"DZ-z","btnContainer":"EZ-z","cartButton":"FZ-z","disabled":"GZ-z"};